import classcat from "classcat";
import React from "react";

import { IconDown, IconUp } from "@touchtech/web-baselayer-ui";

import { AccordionItemType } from "./Accordion.types";
import css from "./AccordionItem.module.css";
import useManageAccordionItem from "./hooks/useManageAccordionItem";

type Props = {
  item: AccordionItemType;
  index: number;
  onClick: (id: string) => void;
  isExpanded: boolean;
  animated?: boolean;
};

const AccordionItem = ({ item, onClick, isExpanded, animated }: Props) => {
  const { handleClick } = useManageAccordionItem({ item, onClick, isExpanded });

  return (
    <div className={css.container}>
      <div onClick={handleClick}>
        {item.renderHeader ? (
          item.renderHeader(isExpanded)
        ) : (
          <div
            className={classcat([css.header, { [css.expanded]: isExpanded }])}
          >
            <span>{item.header}</span>
            <div className={css.iconContainer}>
              {isExpanded ? <IconUp /> : <IconDown />}
            </div>
          </div>
        )}
      </div>
      <div
        data-testid={`accordion-item-content-${item.id}`}
        className={classcat([
          css.content,
          { [css.expanded]: isExpanded, [css.animated]: animated },
        ])}
      >
        <div>{item.content}</div>
      </div>
    </div>
  );
};

export default AccordionItem;
